import { MessageSquare, Clock } from "lucide-react";
import { PHONE, PHONE_TEL, PHONE_HELP, PHONE_HELP_TEL } from "@/lib/api";

export default function CTABand() {
  return (
    <section data-testid="cta-band" className="py-20 md:py-24 bg-[#0B1B3D] text-white relative overflow-hidden">
      <div className="absolute -top-24 -right-24 h-72 w-72 rounded-full bg-[#C5A059]/15 blur-3xl" />
      <div className="absolute -bottom-24 -left-24 h-72 w-72 rounded-full bg-[#2C5545]/25 blur-3xl" />
      <div className="relative max-w-5xl mx-auto px-6 lg:px-8 text-center">
        <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full border border-[#C5A059]/40 bg-white/5 backdrop-blur-sm mb-5">
          <Clock className="h-3.5 w-3.5 text-[#C5A059]" />
          <span className="text-[11px] uppercase tracking-[0.2em] text-[#C5A059]">
            Text or call anytime — help is available 24/7
          </span>
        </div>
        <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl leading-tight mb-4">
          Every day you wait, <em className="text-[#C5A059] not-italic font-medium">your options shrink.</em>
        </h2>
        <p className="text-white/75 max-w-2xl mx-auto mb-8 leading-relaxed">
          Talk to a licensed homeowner advocate today — free, confidential, and no
          obligation. Most calls end with a clear plan in under 20 minutes.
        </p>
        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <a
            href={`sms:${PHONE_TEL}`}
            data-testid="cta-band-phone"
            className="inline-flex flex-col items-center justify-center gap-0.5 px-7 py-3 rounded-lg bg-[#C5A059] hover:bg-[#B38F4E] text-[#0B1B3D] font-semibold transition-all shadow-lg hover:shadow-xl"
          >
            <span className="flex items-center gap-2">
              <MessageSquare className="h-4 w-4" />
              Text {PHONE}
            </span>
            <span className="text-[10px] uppercase tracking-[0.16em] text-[#0B1B3D]/70">Business hours 8am – 5pm</span>
          </a>
          <a
            href={`tel:${PHONE_HELP_TEL}`}
            data-testid="cta-band-help-phone"
            className="inline-flex flex-col items-center justify-center gap-0.5 px-7 py-3 rounded-lg bg-white/10 hover:bg-white/20 border border-white/30 text-white backdrop-blur-sm transition-all"
          >
            <span className="flex items-center gap-2">
              <Clock className="h-4 w-4" />
              24/7 Help: {PHONE_HELP}
            </span>
            <span className="text-[10px] uppercase tracking-[0.16em] text-white/60">Call anytime</span>
          </a>
          <a
            href="#top"
            data-testid="cta-band-form"
            className="inline-flex items-center justify-center gap-2 px-7 py-4 rounded-lg border border-white/30 text-white hover:bg-white/10 backdrop-blur-sm transition-all"
          >
            Free rescue plan
          </a>
        </div>
      </div>
    </section>
  );
}
